import { storage } from '../firebase';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

const VIDEOS_FILE_PATH = 'albums/videos.json';

export const getVideos = async () => {
  try {
    const videosRef = ref(storage, VIDEOS_FILE_PATH);
    const url = await getDownloadURL(videosRef);
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
      },
      signal: AbortSignal.timeout(10000)
    });
    
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }
    
    const videos = await response.json();
    
    // Sort videos by date descending (newest first)
    return videos.sort((a, b) => new Date(b.date) - new Date(a.date));
  } catch (error) {
    console.log('No videos.json found or error loading videos:', error.message);
    return [];
  }
};

export const saveVideos = async (videos) => {
  const videosRef = ref(storage, VIDEOS_FILE_PATH);
  const videosBlob = new Blob([JSON.stringify(videos, null, 2)], { type: 'application/json' });
  await uploadBytes(videosRef, videosBlob);
};

export const saveVideo = async (videoData) => {
  const existingVideos = await getVideos();
  
  const newVideo = {
    id: Date.now().toString(),
    title: videoData.title,
    date: videoData.date,
    link: videoData.link,
    category: videoData.category || '',
    createdAt: new Date().toISOString()
  };
  
  const updatedVideos = [newVideo, ...existingVideos];
  await saveVideos(updatedVideos);
  
  return newVideo;
};

export const deleteVideo = async (videoId) => {
  const existingVideos = await getVideos();
  const updatedVideos = existingVideos.filter(video => video.id !== videoId);
  await saveVideos(updatedVideos);
};

export const getExistingVideoCategories = async () => {
  try {
    const videos = await getVideos();
    const categories = videos
      .map(video => video.category)
      .filter(category => category && category.trim() !== '')
      .filter((category, index, array) => array.indexOf(category) === index) // Remove duplicates
      .sort();
    
    return categories;
  } catch (error) {
    console.error('Error getting existing video categories:', error);
    return [];
  }
};